// components/Contact.js
import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    service: '',
    message: ''
  });

  const [agreement, setAgreement] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleAgreementChange = (e) => {
    setAgreement(e.target.checked);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!agreement) {
      alert('Please agree to the terms before submitting');
      return;
    }
    // Handle form submission here
    console.log('Form submitted:', formData);
  };

  return (
    <section id="contact" className="contact-section fade-in-section">
      <div className="container">
        <h2 className="section-title">Get In Touch</h2>
        <p className="section-subtitle">
          Ready to transform your lead generation? Contact us today for a free consultation.
        </p>
        
        <div className="contact-grid">
          <div className="contact-info">
            <h3>Let's Start a Conversation</h3>
            <p>Get in touch and see how LeadVala can help grow your business with high-quality, verified leads.</p>
            
            <div className="contact-details">
              <div className="contact-item">
                <span className="contact-icon">📍</span>
                <div>
                  <strong>Address</strong>
                  <p>726, Sun Gravitas, Shyamal, Ahmedabad, Gujarat, India</p>
                </div>
              </div>
              
              <div className="contact-item">
                <span className="contact-icon">📞</span>
                <div>
                  <strong>Phone</strong>
                  <p>+91-97999 18691</p>
                </div>
              </div>
              
              <div className="contact-item">
                <span className="contact-icon">✉️</span>
                <div>
                  <strong>Email</strong>
                  <p>contact@leadvala.com</p>
                </div>
              </div>
              
              <div className="contact-item">
                <span className="contact-icon">🌐</span>
                <div>
                  <strong>Website</strong>
                  <p>www.leadvala.com</p>
                </div>
              </div>
            </div>
          </div>
          
          <form className="contact-form" onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
              className="form-input"
              required
            />
            
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              value={formData.email}
              onChange={handleChange}
              className="form-input"
              required
            />
            
            <input
              type="tel"
              name="phone"
              placeholder="Your Phone"
              value={formData.phone}
              onChange={handleChange}
              className="form-input"
              required
            />
            
            <input
              type="text"
              name="company"
              placeholder="Company Name"
              value={formData.company}
              onChange={handleChange}
              className="form-input"
            />
            
            <select
              name="service"
              value={formData.service}
              onChange={handleChange}
              className="form-input"
              required
            >
              <option value="">Select Service Interest</option>
              <option value="call">Call Verified Leads</option>
              <option value="otp">OTP Verified Leads</option>
              <option value="whatsapp">WhatsApp Verified Leads</option>
            </select>
            
            <textarea
              name="message"
              placeholder="Your Message"
              value={formData.message}
              onChange={handleChange}
              className="form-input form-textarea"
              rows="5"
            />
            
            <div className="checkbox-container">
              <input
                type="checkbox"
                id="agreement"
                checked={agreement}
                onChange={handleAgreementChange}
                className="checkbox-input"
              />
              <label htmlFor="agreement" className="checkbox-label">
              By clicking submit, I agree to the terms & conditions and privacy policy and give my consent to receive updates through SMS/Email.
              </label>
            </div>
            
            <button type="submit" className="submit-button">
              Send Message
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;